export enum CalendarViewType {
    Month = 'month',
    Day = 'day',
    Week = 'week'
}
